import { CONTENT_COLLECTION, JOB_COLLECTION, USER_COLLECTION, USER_FIELD_CONTENT_IDS, USER_FILE_COLLECTION } from 'config';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { addDoc, arrayUnion, collection, doc, getDoc, getDocs, getFirestore, query, setDoc, updateDoc, where, deleteDoc, arrayRemove } from "firebase/firestore";
import { getBlob, getStorage, ref } from "firebase/storage";

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '{}');
export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export const getFilesByUID = async (uid: string) => {
  const q = query(collection(db, "users", uid, USER_FILE_COLLECTION));
  return getDocs(q).then((querySnapshot) => {
    return querySnapshot.docs.map((doc) => {
      return doc.data();
    })
  }).catch((error) => {
    throw new Error(error);
  });
}

export const getTranscriptsByUID = async (uid: string) => {
  const q = query(collection(db, "users", uid, USER_FILE_COLLECTION), where("type", "in", ["transcript_source", "transcript_translation"]));
  return getDocs(q).then((querySnapshot) => {
    return querySnapshot.docs.map((doc) => {
      return doc.data();
    })
  }).catch((error) => {
    throw new Error(error);
  });
}

export const getJob = async (jobId: string) => {
  if(!jobId) {
    return null;
  }
  const docRef = doc(db, JOB_COLLECTION, jobId);
  const docSnap = await getDoc(docRef);
  return docSnap.data();
}

export const getAllContent = async (uid: string) => {
  try {
    const user = await getDoc(doc(db, USER_COLLECTION, uid));
    const contentIds = user.data()!.content_ids;
    const contentDocs = await Promise.all(contentIds.map(async (contentId: string) => {
      const contentDoc = await getDoc(doc(db, CONTENT_COLLECTION, contentId));
      return { id: contentId, data: contentDoc.data() }
    }));
    return contentDocs;
  } catch (error) {
    throw error;
  }
}

export const getContent = async (contentId: string) => {
  try {
    const docRef = doc(db, CONTENT_COLLECTION, contentId);
    const contentDoc = await getDoc(docRef);
    return contentDoc.data();
  } catch (error) {
    throw error;
  }
}

export const getUsersContent = async (uid: string) => {
  const user = await getDoc(doc(db, USER_COLLECTION, uid));
  return user.data()!.content_ids;
}

export const getUsersLastContent = async (uid: string) => {
  try {
    const user = await getDoc(doc(db, USER_COLLECTION, uid));
    const contentIds = user.data()!.content_ids || [];
    const contentDoc = contentIds.length ? await getDoc(doc(db, CONTENT_COLLECTION, contentIds[contentIds.length-1])) : null; // dont get doc if it doesnt exist.
    
    return contentIds.length ? contentDoc?.data() : null; 
  } catch (error) {
    throw error;
  }
}

export const addContentDocument = async (uid: string, content: any) => {

  const contentDocRef = await addDoc(collection(db, "content"), content);
  
  await setDoc(doc(db, "users", uid), { [USER_FIELD_CONTENT_IDS]: arrayUnion(contentDocRef.id) }, { merge: true });

  return contentDocRef.id;
}

export const deleteContent = async (uid: string, contentId: string) => {
  const userContentIds = await getUsersContent(uid);
  const userFieldToDelete = userContentIds.find((id: string) => id === contentId);

  await updateDoc(doc(db, USER_COLLECTION, uid), {
    content_ids: arrayRemove(userFieldToDelete),
  })
  await deleteDoc(doc(db, CONTENT_COLLECTION, contentId));
}

export const getFile = async (uid: string, fileId: string) => {
  const q = query(collection(db, USER_COLLECTION, uid, USER_FILE_COLLECTION), where("fileId", "==", fileId));
  const querySnapshot = await getDocs(q);
  const data = querySnapshot.docs[0].data();
  if(!data) {
    throw new Error(`File ${fileId} not found`);
  }
  return data.remoteFilePath

}

export const getAllTestContent = async (uid: string) => {
  const collectionRef = collection(db, "users", uid, USER_FILE_COLLECTION);
  return getDocs(collectionRef).then((querySnapshot) => {
    return querySnapshot.docs.map((doc) => {
      return { id: doc.id, data: doc.data() };
    })
  }).catch((error) => {
    throw new Error(error);
  });
}


export const getTestContent = async (uid: string, contentId: string) => {
  const docRef = doc(db, "users", uid, "files", contentId);
  return getDoc(docRef).then((doc) => {
    if (doc.exists()) {
      return doc.data();
    } else {
      throw new Error("No such document!");
    }
  }).catch((error) => {
    throw new Error(error);
  });
}

// firebase storage
const storage = getStorage(app, "gs://seperated-audio");

export async function downloadFile(filename: string) {
  const reference = ref(storage, filename);
  console.log(reference);
  console.log(filename);
  return getBlob(reference)
    .then((blob) => {
      return blob;
    }).catch((error) => {
      throw new Error(error);
    });
}